<template>
  <div class="_component-radio-slot" :class="{ active: value, disabled: disabled }" @click="handleClick">
    <div class="component-radio-render"></div>
    <div class="component-contnet-wrap">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RadioSlot',
  props: {
    value: {
      default: false
    },
    disabled: {
      default: false
    }
  },
  methods: {
    handleClick() {
      if (!this.disabled) {
        this.$emit('input', !this.value);
      }
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
